import { stats } from '@/mocks/shows';

export default function StatsCounter() {
  return (
    <section className="w-full px-4 md:px-6 py-12 md:py-16 bg-primary-500">
      <div className="max-w-7xl mx-auto">
        <div className="grid grid-cols-2 lg:grid-cols-4 gap-6 md:gap-8">
          {stats.map((stat, index) => (
            <div key={index} className="text-center">
              <div className="text-3xl md:text-4xl font-heading text-background-50 mb-2">
                {stat.value}
              </div>
              <div className="text-sm text-background-200">
                {stat.label}
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}